<template>
  <div>
    <div class="header">
      <div class="top">
        <div class="title">
          围棋等级考试
        </div>
      </div>
    </div>
    <iframe :src="url" frameborder="0" width="100%" height="1000" scrolling="no" ref="iframe"></iframe>
  </div>
</template>

<script>
export default{
  data () {
    return {
      url: ''
    }
  },
  created () {
    var name = this.$route.params.name
    this.url = encodeURI('static/public/Go_test/go_test.html?name=' + name +
                 '&levelexam=' + this.$route.params.levelexam +
                 '&testId=' + this.$route.params.id +
                 '&exchangCode=' + this.$route.params.exchangCode +
                 '&gradId=' + this.$route.params.testId)
    console.log(name)
  }
}
</script>

<style scoped lang='scss'>
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .header{
    width:100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    height: 140px;
    background-color: #008EE9;
    .top{
      width: 100%;
      @media only screen and (min-width: 540px) and (max-width: 1180px){
        width: 1180px;
      }
      height: 140px;
      @include flex();
      padding: 0 95px;
      margin: 0 auto;
      box-sizing: border-box;
      .title{
        background-color: #008de9;
        color: #fff;
        font-size: 50px;
        font-family: 'SimSun';
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/go_test/chessTest.vue